// NO EDITAR A MANO
import type {
    Footer as Modulo,
    FooterCopyrightParams
} from "../../../footer";
import type {FooterLinkApps} from "../../../footer/link_apps";
import type {FooterLinkLegal} from "../../../footer/link_legal";
import type {FooterLinkSocial} from "../../../footer/link_social";

import link_apps from "./link_apps";
import link_legal from "./link_legal";
import link_social from "./link_social";

import copyright from "./copyright";
import h3_footer from "./h3_footer";
import text_footer from "./text_footer";

class Footer implements Modulo {
    /* STATIC */
    // public static ID: string = "footer";
    // public static VERSION: string = "2025.2.11-162203";
    // public static HASH: string = "48f1158b64a62b362d263bdeab7fc835";

    /* INSTANCE */
    public readonly link_apps: FooterLinkApps;
    public readonly link_legal: FooterLinkLegal;
    public readonly link_social: FooterLinkSocial;

    public readonly h3_footer: string;
    public readonly text_footer: string;

    public constructor() {
        this.h3_footer = h3_footer;
        this.link_apps = link_apps;
        this.link_legal = link_legal;
        this.link_social = link_social;
        this.text_footer = text_footer;
    }

    public copyright(params: Partial<FooterCopyrightParams> = {}) { return copyright.render(params); }
}

export default new Footer();
